import { ApiResponse, postRequest } from "@/data/apiClient";
import { LoginResponse } from "@/data/repos/passwordLogin";

export type msSsoRequest = {
  id_token: string;
  session_state: string;
  state: string;
};
export type googleSsoRequest = {
  access_token: string;
  authuser: string;
  expires_in: string;
  hd: string;
  prompt: string;
  scope: string;
  state: string;
  token_type: string;
};

export const ssoLoginMS = (
  req: msSsoRequest,
  clientKey: string | (string | null)[] | undefined = undefined,
  app: string | undefined = undefined
): Promise<ApiResponse<LoginResponse>> =>
  postRequest(
    "ssoLogin?type=microsoft" +
      (app ? `&app=${app}` : "") +
      (clientKey ? `&clientKey=${clientKey}` : ""),
    req
  );
export const ssoLoginGoogle = (
  req: googleSsoRequest,
  clientKey: string | (string | null)[] | undefined = undefined,
  app: string | undefined = undefined
): Promise<ApiResponse<LoginResponse>> =>
  postRequest(
    "ssoLogin?type=google" +
      (app ? `&app=${app}` : "") +
      (clientKey ? `&clientKey=${clientKey}` : ""),
    req
  );
